import React from 'react'

import PropTypes from 'prop-types'
import { Box, IconButton, Typography } from '@material-ui/core'
import { Trash as TrashIcon } from 'react-feather'
import { isEmpty } from 'lodash'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useStyles from './styles'

const StagedFragilitiesTable = ({
  stagedFragilities,
  setStagedFragilities,
  saving,
}) => {
  const classes = useStyles()

  const handleRemove = (index) =>
    setStagedFragilities((current) =>
      current.filter((_, itemIndex) => itemIndex !== index),
    )

  return (
    <Box className={classes.tableContainer}>
      <Table size="small" noWrap stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="left" width="80%">
              Ameaças adicionadas
            </TableCell>
            <TableCell align="right" width="20%">
              Ações
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(stagedFragilities) ? (
            stagedFragilities.map((item, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <Typography variant="body2">{item.name}</Typography>
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() => handleRemove(index)}
                    disabled={saving}
                  >
                    <TrashIcon size={20} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="left" className={classes.empty}>
                <Typography variant="caption">
                  Nenhuma ameaça adicionada.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  )
}

StagedFragilitiesTable.propTypes = {
  stagedFragilities: PropTypes.array,
  setStagedFragilities: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default StagedFragilitiesTable
